import React from "react";
import "./style.scss";
import get from "lodash/get";
import { DisabledOverlay } from "../DisabledOverlay";

export function resolveTextValue({ DbData, data }) {
    const isAge = data.source === "patient.new-age";
    let text = get(DbData, data.source, data.data);
    if (isAge) {
        const ages = get(DbData, "patient.ages", 0);
        const months = get(DbData, "patient.months", 0);
        text = !!ages ? `${ages} y.o.` : `${months} m.o.`;
    }
    return text;
}

export const Text = ({ DbData, data, updateState, disabled }) => {
    const text = resolveTextValue({ DbData, data });
  return (
    <span
      className="emr-note-text emr-note-text_inner-text"
      onBlur={(e) => {
        updateState({ ...data, data: e.target.innerText });
      }}
      contentEditable={data.editable}
    >
      <span>{text}</span>
      <DisabledOverlay show={disabled} />
    </span>
  );
};
